import esLocal from "date-fns/locale/es";
import enLocale from "date-fns/locale/en-US";

const dateFnsLocales = { es: esLocal, en: enLocale };

export default dateFnsLocales;
